const calculateDimensions = ({
  containers,
  selectedContainerId,
  selectedDepth,
  selectedFoodPanSize,
  foodPans,
  length = 0,
  width = 0,
  height = 0,
  measurement,
}) => {
  if (selectedContainerId === "Reset") return resetValues()
  if (selectedDepth === "Reset") return resetValues()
  if (selectedDepth) return calculateDimensionsFromPan()
  if (selectedContainerId) return calculateDimensionsFromContainer()
  return calculateDimensionsFromValues()

  function resetValues() {
    return { width: "", height: "", length: "", boxCount: "" }
  }

  function calculateDimensionsFromContainer() {
    const measurements = measurementsFor(getContainer())
    if (measurement === "metric") return convertToMetric(measurements)
    return measurements
  }

  function getContainer() {
    return containers.filter(
      (container) => container.id == selectedContainerId
    )[0]
  }

  function calculateDimensionsFromPan() {
    const measurements = measurementsFor(getPan())
    if (measurement === "metric") return convertToMetric(measurements)
    return measurements
  }

  function getPan() {
    return foodPans.filter(
      (pan) =>
        pan.size == selectedFoodPanSize.split(" ")[0] &&
        pan.height == selectedDepth
    )[0]
  }

  function convertToMetric({ width, length, height }) {
    return {
      width: Number((width * 2.54).toFixed(2)),
      length: Number((length * 2.54).toFixed(2)),
      height: Number((height * 2.54).toFixed(2)),
    }
  }

  function convertToImperial({ width, length, height }) {
    return {
      width: Number((width / 2.54).toFixed(2)),
      length: Number((length / 2.54).toFixed(2)),
      height: Number((height / 2.54).toFixed(2)),
    }
  }

  function measurementsFor(container) {
    return {
      width: Number(parseFloat(container?.width ?? 0).toFixed(2)),
      length: Number(parseFloat(container?.length ?? 0).toFixed(2)),
      height: Number(parseFloat(container?.height ?? 0).toFixed(2)),
    }
  }

  function calculateDimensionsFromValues() {
    if (measurement === "metric")
      return convertToMetric({ width, length, height })
    return convertToImperial({ width, length, height })
  }
}

export default calculateDimensions
